import storage from 'good-storage'

export class BaseCache {
  constructor(session) {
    this.key = 'base';
    this.storage = session ? storage.session : storage;
  }

  get() {
    return this.storage.get(this.key, null);
  }

  set(value) {
    this.storage.set(this.key, value);
  }
}
